var render = function () {
  var _vm$user$createdAt, _vm$user$createdAt$to, _vm$user, _vm$user$avatar, _vm$user2, _vm$user2$avatar, _vm$user3;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-layout', {
    attrs: {
      "justify-center": ""
    }
  }, [_c('v-responsive', {
    staticClass: "shop-product-view",
    attrs: {
      "max-width": "1440px",
      "width": "100%",
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "headline text-start mt-8"
  }, [_vm.user._id ? _c('span', [_vm._v("사용자 상세")]) : _c('span', [_vm._v("사용자 등록")])]), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "9"
    }
  }, [_c('v-card', {
    staticClass: "mb-2",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', {
    staticClass: "subtitle-2 font-weight-bold"
  }, [_vm._v("계정정보")]), _c('v-card-text', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('v-text-field', _vm._b({
    attrs: {
      "label": "아이디",
      "readonly": ""
    },
    model: {
      value: _vm.user.username,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "username", $$v);
      },
      expression: "user.username"
    }
  }, 'v-text-field', _vm.attrs_input, false))], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('v-text-field', _vm._b({
    attrs: {
      "label": "회원유형",
      "readonly": ""
    },
    model: {
      value: _vm.user.title,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "title", $$v);
      },
      expression: "user.title"
    }
  }, 'v-text-field', _vm.attrs_input, false))], 1)], 1), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('v-text-field', _vm._b({
    attrs: {
      "label": "비밀번호",
      "placeholder": "비밀번호 변경 시 입력"
    },
    model: {
      value: _vm.user.password,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "password", $$v);
      },
      expression: "user.password"
    }
  }, 'v-text-field', _vm.attrs_input, false))], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('v-text-field', _vm._b({
    attrs: {
      "value": (_vm$user$createdAt = _vm.user.createdAt) === null || _vm$user$createdAt === void 0 ? void 0 : (_vm$user$createdAt$to = _vm$user$createdAt.toDate) === null || _vm$user$createdAt$to === void 0 ? void 0 : _vm$user$createdAt$to.call(_vm$user$createdAt),
      "label": "가입일",
      "readonly": "",
      "placeholder": "비밀번호 변경 시 입력"
    }
  }, 'v-text-field', _vm.attrs_input, false))], 1)], 1)], 1)], 1), _c('v-card', {
    staticClass: "mb-2",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', {
    staticClass: "subtitle-2 font-weight-bold"
  }, [_vm._v("기본정보")]), _c('v-card-text', [_vm.isOrganization ? _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('v-text-field', _vm._b({
    attrs: {
      "label": "기업명"
    },
    model: {
      value: _vm.user.companyName,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "companyName", $$v);
      },
      expression: "user.companyName"
    }
  }, 'v-text-field', _vm.attrs_input, false))], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('v-text-field', _vm._b({
    attrs: {
      "label": "사업자등록번호"
    },
    model: {
      value: _vm.user.businessNumber,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "businessNumber", $$v);
      },
      expression: "user.businessNumber"
    }
  }, 'v-text-field', _vm.attrs_input, false))], 1)], 1) : _vm._e(), _vm.isOrganization ? _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('v-text-field', _vm._b({
    attrs: {
      "label": "대표자명"
    },
    model: {
      value: _vm.user.ceoName,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "ceoName", $$v);
      },
      expression: "user.ceoName"
    }
  }, 'v-text-field', _vm.attrs_input, false))], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('v-text-field', _vm._b({
    attrs: {
      "label": "기업설립일",
      "type": "date"
    },
    model: {
      value: _vm.user.establishedAt,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "establishedAt", $$v);
      },
      expression: "user.establishedAt"
    }
  }, 'v-text-field', _vm.attrs_input, false))], 1)], 1) : _vm._e(), !_vm.isOrganization ? _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('v-text-field', _vm._b({
    attrs: {
      "label": "이름"
    },
    model: {
      value: _vm.user.name,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "name", $$v);
      },
      expression: "user.name"
    }
  }, 'v-text-field', _vm.attrs_input, false))], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('v-text-field', _vm._b({
    attrs: {
      "label": _vm.isStudent ? '학교/학과' : '소속/부서'
    },
    model: {
      value: _vm.user.affiliation,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "affiliation", $$v);
      },
      expression: "user.affiliation"
    }
  }, 'v-text-field', _vm.attrs_input, false))], 1)], 1) : _vm._e(), _vm.isIndividual && !_vm.isSupporter ? _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('v-text-field', _vm._b({
    attrs: {
      "label": "생년월일",
      "readonly": ""
    },
    model: {
      value: _vm.user.bornAt,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "bornAt", $$v);
      },
      expression: "user.bornAt"
    }
  }, 'v-text-field', _vm.attrs_input, false))], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  })], 1) : _vm._e(), _vm.isElse ? _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('v-text-field', _vm._b({
    attrs: {
      "label": "성별"
    },
    model: {
      value: _vm.user.gender,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "gender", $$v);
      },
      expression: "user.gender"
    }
  }, 'v-text-field', _vm.attrs_input, false))], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('v-text-field', _vm._b({
    attrs: {
      "label": "지역"
    },
    model: {
      value: _vm.user.region,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "region", $$v);
      },
      expression: "user.region"
    }
  }, 'v-text-field', _vm.attrs_input, false))], 1)], 1) : _vm._e(), !_vm.isSupporter ? _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('v-text-field', _vm._b({
    attrs: {
      "label": "연락처"
    },
    model: {
      value: _vm.user.phone,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "phone", $$v);
      },
      expression: "user.phone"
    }
  }, 'v-text-field', _vm.attrs_input, false))], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('v-text-field', _vm._b({
    attrs: {
      "label": "이메일"
    },
    model: {
      value: _vm.user.email,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "email", $$v);
      },
      expression: "user.email"
    }
  }, 'v-text-field', _vm.attrs_input, false))], 1)], 1) : _vm._e(), !_vm.isSupporter ? _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "2"
    }
  }, [_c('v-text-field', _vm._b({
    attrs: {
      "label": "우편번호",
      "readonly": ""
    },
    on: {
      "click": function click($event) {
        return _vm.$refs.DaumPostcode.open();
      }
    },
    model: {
      value: _vm.user.postcode,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "postcode", $$v);
      },
      expression: "user.postcode"
    }
  }, 'v-text-field', _vm.attrs_input, false))], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "lg": ""
    }
  }, [_c('v-text-field', _vm._b({
    attrs: {
      "label": "기본주소",
      "readonly": ""
    },
    on: {
      "click": function click($event) {
        return _vm.$refs.DaumPostcode.open();
      }
    },
    model: {
      value: _vm.user.address1,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "address1", $$v);
      },
      expression: "user.address1"
    }
  }, 'v-text-field', _vm.attrs_input, false))], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "lg": ""
    }
  }, [_c('v-text-field', _vm._b({
    attrs: {
      "label": "상세주소"
    },
    model: {
      value: _vm.user.address2,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "address2", $$v);
      },
      expression: "user.address2"
    }
  }, 'v-text-field', _vm.attrs_input, false))], 1)], 1) : _vm._e()], 1)], 1), _c('v-card', {
    staticClass: "mb-2",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', {
    staticClass: "subtitle-2 font-weight-bold"
  }, [_vm._v(" " + _vm._s(_vm.isSupporter ? "자문분야" : "관심분야") + " ")]), _c('v-card-text', [_vm.user._areas ? _c('user-areas', {
    attrs: {
      "areas": _vm.areas
    },
    model: {
      value: _vm.user,
      callback: function callback($$v) {
        _vm.user = $$v;
      },
      expression: "user"
    }
  }) : _vm._e()], 1)], 1), _vm.isSupporter ? _c('v-card', {
    staticClass: "mb-2",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', {
    staticClass: "subtitle-2 font-weight-bold"
  }, [_vm._v(" 공개정보 ")]), _c('v-card-text', [_c('v-row', [_c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "5"
    }
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', _vm._b({
    attrs: {
      "label": "닉네임"
    },
    model: {
      value: _vm.user.nickname,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "nickname", $$v);
      },
      expression: "user.nickname"
    }
  }, 'v-text-field', _vm.attrs_input, false))], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', _vm._b({
    attrs: {
      "label": "연락처"
    },
    model: {
      value: _vm.user.phone,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "phone", $$v);
      },
      expression: "user.phone"
    }
  }, 'v-text-field', _vm.attrs_input, false))], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', _vm._b({
    attrs: {
      "label": "이메일"
    },
    model: {
      value: _vm.user.email,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "email", $$v);
      },
      expression: "user.email"
    }
  }, 'v-text-field', _vm.attrs_input, false))], 1)], 1), _c('image-input', {
    attrs: {
      "label": "전문가 사진",
      "imageSrc": (_vm$user = _vm.user) === null || _vm$user === void 0 ? void 0 : (_vm$user$avatar = _vm$user.avatar) === null || _vm$user$avatar === void 0 ? void 0 : _vm$user$avatar.url
    },
    model: {
      value: _vm.avatar,
      callback: function callback($$v) {
        _vm.avatar = $$v;
      },
      expression: "avatar"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "7"
    }
  }, [_c('v-textarea', _vm._b({
    attrs: {
      "label": "전문가 소개",
      "rows": "8"
    },
    model: {
      value: _vm.user.summary,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "summary", $$v);
      },
      expression: "user.summary"
    }
  }, 'v-textarea', _vm.attrs_input, false))], 1)], 1)], 1)], 1) : _vm._e(), _vm.isOrganization ? _c('v-card', {
    staticClass: "mb-2",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', {
    staticClass: "subtitle-2 font-weight-bold"
  }, [_vm._v(" 상세정보 ")]), _c('v-card-text', [_c('v-row', [_c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "5"
    }
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', _vm._b({
    attrs: {
      "label": "홈페이지 주소"
    },
    model: {
      value: _vm.user.website,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "website", $$v);
      },
      expression: "user.website"
    }
  }, 'v-text-field', _vm.attrs_input, false))], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "lg": ""
    }
  }, [_c('v-text-field', _vm._b({
    attrs: {
      "label": "담당자 이름"
    },
    model: {
      value: _vm.user.workerName,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "workerName", $$v);
      },
      expression: "user.workerName"
    }
  }, 'v-text-field', _vm.attrs_input, false))], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "lg": ""
    }
  }, [_c('v-text-field', _vm._b({
    attrs: {
      "label": "담당자 직책"
    },
    model: {
      value: _vm.user.workerTitle,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "workerTitle", $$v);
      },
      expression: "user.workerTitle"
    }
  }, 'v-text-field', _vm.attrs_input, false))], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', _vm._b({
    attrs: {
      "label": "주요생산제품"
    },
    model: {
      value: _vm.user.mainProduct,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "mainProduct", $$v);
      },
      expression: "user.mainProduct"
    }
  }, 'v-text-field', _vm.attrs_input, false))], 1)], 1), _c('image-input', {
    attrs: {
      "label": "기업로고",
      "imageSrc": (_vm$user2 = _vm.user) === null || _vm$user2 === void 0 ? void 0 : (_vm$user2$avatar = _vm$user2.avatar) === null || _vm$user2$avatar === void 0 ? void 0 : _vm$user2$avatar.url,
      "rounded": ""
    },
    model: {
      value: _vm.avatar,
      callback: function callback($$v) {
        _vm.avatar = $$v;
      },
      expression: "avatar"
    }
  }), _c('files-input', {
    attrs: {
      "label": "소개자료"
    },
    model: {
      value: _vm.brochures,
      callback: function callback($$v) {
        _vm.brochures = $$v;
      },
      expression: "brochures"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "7"
    }
  }, [_c('v-textarea', _vm._b({
    attrs: {
      "label": "기업소개",
      "rows": "13"
    },
    model: {
      value: _vm.user.summary,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "summary", $$v);
      },
      expression: "user.summary"
    }
  }, 'v-textarea', _vm.attrs_input, false))], 1)], 1)], 1)], 1) : _vm._e(), _vm.isSupporter || _vm.isOrganization ? _c('user-description', {
    model: {
      value: _vm.user,
      callback: function callback($$v) {
        _vm.user = $$v;
      },
      expression: "user"
    }
  }) : _vm._e()], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "3"
    }
  }, [_vm.isOrganization || _vm.isSupporter ? _c('v-card', {
    staticClass: "mb-2",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', {
    staticClass: "subtitle-2 font-weight-bold"
  }, [_vm._v("계정상태")]), _c('v-card-text', {
    staticClass: "caption primary--text"
  }, [_vm.isSupporter ? _c('v-switch', _vm._b({
    attrs: {
      "label": "가입승인"
    },
    model: {
      value: _vm.user.isApproval,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "isApproval", $$v);
      },
      expression: "user.isApproval"
    }
  }, 'v-switch', _vm.attrs_switch, false)) : _vm._e(), _c('v-switch', _vm._b({
    attrs: {
      "label": "전문기업/전문가승인"
    },
    model: {
      value: _vm.user.isExpert,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "isExpert", $$v);
      },
      expression: "user.isExpert"
    }
  }, 'v-switch', _vm.attrs_switch, false)), _c('v-switch', _vm._b({
    attrs: {
      "label": "검색노출"
    },
    model: {
      value: _vm.user.isDisplayed,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "isDisplayed", $$v);
      },
      expression: "user.isDisplayed"
    }
  }, 'v-switch', _vm.attrs_switch, false)), _c('v-switch', _vm._b({
    staticStyle: {
      "margin-bottom": "0 !important"
    },
    attrs: {
      "label": "연락처노출"
    },
    model: {
      value: _vm.user.isContactDisplayed,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "isContactDisplayed", $$v);
      },
      expression: "user.isContactDisplayed"
    }
  }, 'v-switch', _vm.attrs_switch, false))], 1)], 1) : _vm._e(), _c('v-card', {
    staticClass: "mb-2",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', {
    staticClass: "subtitle-2 font-weight-bold"
  }, [_vm._v("QR코드")]), _c('v-card-text', [_c('qrcode-vue', {
    staticClass: "d-flex justify-center pa-4",
    attrs: {
      "value": (_vm$user3 = _vm.user) === null || _vm$user3 === void 0 ? void 0 : _vm$user3._id,
      "size": 103
    }
  })], 1)], 1), _c('v-card', {
    staticClass: "mb-2",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', {
    staticClass: "subtitle-2 font-weight-bold"
  }, [_vm._v("MES")]), _c('v-card-text', [_c('v-switch', _vm._b({
    attrs: {
      "label": "부품조회표기"
    },
    model: {
      value: _vm.user.mes.showsMaterialList,
      callback: function callback($$v) {
        _vm.$set(_vm.user.mes, "showsMaterialList", $$v);
      },
      expression: "user.mes.showsMaterialList"
    }
  }, 'v-switch', _vm.attrs_switch, false)), _c('v-switch', _vm._b({
    attrs: {
      "label": "일정조회표기"
    },
    model: {
      value: _vm.user.mes.showsScheduleList,
      callback: function callback($$v) {
        _vm.$set(_vm.user.mes, "showsScheduleList", $$v);
      },
      expression: "user.mes.showsScheduleList"
    }
  }, 'v-switch', _vm.attrs_switch, false))], 1)], 1), _c('v-card', {
    staticClass: "mb-2",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', {
    staticClass: "subtitle-2 font-weight-bold"
  }, [_vm._v("관리자 메모")]), _c('v-card-text', [_c('v-textarea', {
    attrs: {
      "outlined": "",
      "hide-details": "",
      "rows": "10"
    },
    model: {
      value: _vm.user.note,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "note", $$v);
      },
      expression: "user.note"
    }
  })], 1)], 1)], 1)], 1), _c('v-btn', {
    attrs: {
      "fab": "",
      "fixed": "",
      "right": "",
      "bottom": "",
      "color": "primary",
      "x-large": ""
    },
    on: {
      "click": _vm.save
    }
  }, [_c('v-icon', {
    attrs: {
      "x-large": ""
    }
  }, [_vm._v("mdi-content-save")])], 1)], 1), _c('daum-postcode', {
    ref: "DaumPostcode",
    on: {
      "input": function input(_ref) {
        var postcode = _ref.postcode,
            address = _ref.address;
        _vm.user.postcode = postcode;
        _vm.user.address1 = address;
      }
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }